export default __webpack_public_path__ + "static/media/shoes1.3e95023e.jpg";